import { Component, ElementRef, model, ViewChild } from '@angular/core'
//import { TableauViz, Toolbar } from '@tableau/embedding-api'
import { ReportService } from './report.service'
import { tap } from 'rxjs'

@Component({
   selector: 'vc-report-poc',
   imports: [],
   templateUrl: './report-poc.component.html',
   styleUrl: './report-poc.component.scss',
})
export class ReportPocComponent {
   constructor(private reportService: ReportService) {}

   isInitialized = model<boolean>(false)

   @ViewChild('container')
   container!: ElementRef

   ngAfterViewInit(): void {
      // Once the token is fetched, embed the Tableau visualization

      if (this.isInitialized()) return

      /*this.reportService
         .fetchToken()
         .pipe(
            tap((token) => {
               console.log('✅ Token fetched successfully: ', token)
               // https://prod-useast-b.online.tableau.com/#/site/vetcor/views/PortfolioDashboard_17424977006620/PortfolioDashboard
               var tableauViz = new TableauViz()
               tableauViz.hideTabs = true
               tableauViz.hideEditButton = true
               tableauViz.hideEditInDesktopButton = true
               tableauViz.toolbar = Toolbar.Hidden
               // tableauViz.toolbar
               tableauViz.token = token

               tableauViz.src =
                  'https://prod-useast-b.online.tableau.com/#/site/vetcor/views/SummaryDashboard-BusinessDateLogic_17472305295270/SummaryDashboard'
               //tableauViz.src = 'https://prod-useast-b.online.tableau.com/t/vetcor/views/Practices/Practices.png'

               console.log('Setting')
               this.container.nativeElement.appendChild(tableauViz)

               console.log('Set')
               this.isInitialized.set(true)
            })
         )
         .subscribe()
		 */
   }
}
